import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useLocation } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { getModel } from './selectors';
import * as actions from './actions';
import PowertrainOverviewComponent from './PowertrainOverviewComponent';
import { userLoggedIn } from './helper';
import authHelper from 'helpers/authHelper';
import storageHelper from 'helpers/localStorageHelper';
import { routes } from 'routes';

import './style.scss';

const PowertrainOverviewContainer = (props) => {
    const location = useLocation();
    const history = useHistory();
    const selectedOrganization = props?.model?.selectedGeneralFilter?.organizations[0];
    const organizationID = selectedOrganization?.organizationID;
    const isNonPowertrainOrganization = selectedOrganization?.isPowertrainOrganization === false;

    useEffect(() => {
        const isCIAMOrgRoute = [
            routes.ToolsUserManagement,
            routes.ToolsAssetManagement,
            routes.UserProfile
        ].includes(location.pathname);

        if (isNonPowertrainOrganization && !isCIAMOrgRoute) {
            history.push(routes.ToolsUserManagement);
        }
    }, [history, isNonPowertrainOrganization, location.pathname]);

    useEffect(() => {
        props.actions.checkTokenExpiration();
    }, [location.pathname]);


    const redirectToLogin = () => {
        authHelper.redirectToLogin(location.pathname + location.search);
    };

    useEffect(() => {
        props.model.userManager?.getUser().then((userCredentials) => {
            if (userLoggedIn(userCredentials, location.pathname)) {
                props.actions.checkTokenExpiration().then(() => {
                    props.actions.getUser();
                    const user = storageHelper.getItem('user');
                    if (user?.broadcastMessageID) {
                        props.actions.loadBroadcastMessages(user.broadcastMessageID);
                    }
                });
                props.actions.getUserCapabilities(organizationID);
            } else {
                redirectToLogin();
            }
        });
    }, [organizationID]);

    return props.model.user &&
        props.model.userCapabilitiesLoadingStatus &&
        <PowertrainOverviewComponent {...props} />;
};

PowertrainOverviewContainer.propTypes = {
    actions: PropTypes.shape({
        checkTokenExpiration: PropTypes.func.isRequired,
        getUser: PropTypes.func.isRequired,
        getUserCapabilities: PropTypes.func.isRequired,
        loadBroadcastMessages: PropTypes.func.isRequired
    }).isRequired,
    model: PropTypes.shape({
        userManager: PropTypes.shape({
            getUser: PropTypes.func.isRequired
        }).isRequired,
        user: PropTypes.object,
        userCapabilitiesLoadingStatus: PropTypes.string,
        selectedGeneralFilter: PropTypes.shape({
            organizations: PropTypes.arrayOf(PropTypes.shape({
                organizationID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                isPowertrainOrganization: PropTypes.bool
            }))
        }).isRequired
    }).isRequired
};

const mapStateToProps = (state) => {
    const model = getModel(state);
    return {
        model
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
};

const PowertrainOverviewContainerConn = connect(
    mapStateToProps,
    mapDispatchToProps
)(PowertrainOverviewContainer);

export default PowertrainOverviewContainerConn;
